<template>
    <div>
        <b-spinner v-if="!items" />
        <b-row>
            <h5 v-if="items.length < 1" style="width:100%;text-align:center"> {{ $t('noWorkflowErrors') }} </h5>

            <b-col cols="12" v-if="items.length > 0"> <b-button variant="danger" @click="removeAll">{{ $t('removeAll')
                    }}</b-button> </b-col>


            <b-col sm="12" md="4" v-for="item in items" :key="item._id" class="mt-4">
                <div class="workflow-error">
                    <div class="heading">
                        {{ $toUserTimeZone(item.last_occurence) }}
                        <span @click="remove(item)"> <i class="fa fa-close"></i> </span>
                    </div>

                    <p>
                        {{ item.message }}
                    </p>

                    <small>
                        {{ $t('occured') }} : {{ item.occured }}
                    </small>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<style lang="scss">
.workflow-error {
    border-radius: 10px;
    padding: 20px;
    box-shadow: rgb(0 0 0 / 25%) 0px 25px 50px -12px;
    background: rgba(246, 72, 70, 0.1);

    .heading {
        text-align: right;
        font-size: 12px;
        margin-bottom: 10px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        padding-bottom: 10px;
    }

    .fa-close {
        margin-left: 20px;
        cursor: pointer;

        &:hover {
            color: var(--form-bg);
        }
    }
}
</style>

<script>
export default {
    name: 'Workflow',
    data: function () {
        return {
            items: null
        }
    },

    methods: {
        remove(item) {
            this.$workflowApi.delete("/errors/" + item._id).then(resp => {
                this.items = this.items.filter(i => {
                    return i._id != item._id
                })
            }).catch(err => {
                console.error(err)
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger',
                    title: "Error"
                })
            })
        },

        async removeAll() {
            const confirm = await this.$mainDialog.msgBoxConfirm(`${this.$t('areYouSure')}?`)
            if (!confirm) return

            this.$workflowApi.delete("/errors").then(resp => {
                this.items = []
            }).catch(err => {
                console.error(err)

                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger',
                    title: "Error"
                })
            })
        }
    },

    mounted() {
        this.$workflowApi.get("/errors").then(resp => {
            this.items = resp.data || []
        }).catch(err => {
            console.error(err)

            this.$bvToast.toast(this.$t('unexpectedError'), {
                variant: 'danger',
                title: "Error"
            })
        })
    }
}
</script>